var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisconnectAds(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    iconName: "IconPersonXFill",
    className: "css-6xix1i",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 2.5a10 10 0 1 0 0 20 10 10 0 0 0 0-20ZM19 25.5c-10.94 0-17 7.92-17 14.44 0 3.56 2 3.56 9 3.56h12.82a14.94 14.94 0 0 1-1.66-17.77c-1-.15-2.05-.23-3.16-.23ZM24 33.5a11 11 0 1 1 21.99-.01A11 11 0 0 1 24 33.5Zm8.06-5.54a1 1 0 0 0-1.42 0l-1.18 1.18a1 1 0 0 0 0 1.41l2.95 2.95-2.95 2.95a1 1 0 0 0 0 1.41l1.18 1.18a1 1 0 0 0 1.41 0L35 36.1l2.95 2.94a1 1 0 0 0 1.41 0l1.18-1.18a1 1 0 0 0 0-1.41L37.6 33.5l2.94-2.94a1 1 0 0 0 0-1.42l-1.18-1.18a1 1 0 0 0-1.41 0L35 30.91l-2.94-2.95Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnectAds);
export default __webpack_public_path__ + "static/media/disconnect-ads.f3c189b4647473b64439d3bf77109b44.svg";
export { ForwardRef as ReactComponent };